// extracted by mini-css-extract-plugin
export default {"settingsRowList":"SettingsRowList_settingsRowList__FHCiL","settingsRow":"SettingsRowList_settingsRow__yBQBe"};